
export {Enter,
EnterCommand,
EnterObserver,
ShiftEnter,
ShiftEnterCommand,
_getCopyOnEnterAttributes} from '../../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-enter$dist$index.js.js';
